export var PING_PONG_TIMELINE = "pingPong";
export var PROGRESS_TIMELINE = "progress";
export var TIMELINE_TYPES = [PING_PONG_TIMELINE, PROGRESS_TIMELINE];
